export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_ACCOUNT_NAME = "SET_ACCOUNT_NAME";
